import { Appraisal } from './Appraisal'
import { OperationService } from './OperationService'

export class RankingEvaluator {
	public id_evaluator: string
	public name_evaluator: string
	public media_evaluator: string
	public next_appointment: string
	public distance: number
	public appraisals: Array<Appraisal>
	public scheduled_appraisals: number
	public checked: boolean
}

export class RankingOperator {
	public id: string
	public name: string
	public media: string
	public next_appointment: string
	public distance: number
	public operations: Array<OperationService>
	public scheduled: number
	public checked: boolean
}

export class OperatorListScheduler {
	public idMongo: string = ''
		public name: string = ''
		public media: string = ''
		public companyServiceProvider: string = ''
		public schedulerAmount: number = 0
		public Address: {
				lat: number,
				lng: number
		}
		public distance: string = ''
	public nextOperation: string = ''
	public checked: boolean = false
}
